<template>
  <label class="container-checkbox" >
    <span :class="[{ 'light-label': lightLabel }]" v-html="label"></span>
    <slot></slot>
    <input type="checkbox" :value="value" v-model="proxyChecked" />
    <div class="checkbox-check-indicator" :style="cssProps"></div>
  </label>
</template>
<script>
export default {
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    label: { type: String, required: true },
    checked: {
      type: [Array, Boolean, Object, String],
      default: false
    },
    value: {
      default: null
    },
    lightLabel: Boolean,
    activeColor: {
      type: String,
      default: "var(--orange-web)"
    },
    inactiveColor: {
      type: String,
      default: "#e2e2e2"
    }
  },
  computed: {
    proxyChecked: {
      get() {
        return this.convertStringIfBool();
      },
      set(val) {
        this.$emit("change", val);
      }
    },
    cssProps() {
      return { "--active-color": this.activeColor, "--inactive-color": this.inactiveColor };
    }
  },
  methods: {
    convertStringIfBool() {
      if (typeof this.checked == "string") {
        switch (this.checked) {
          case "true":
            return true;
          case "false":
            return false;
          default:
            return this.checked;
        }
      } else return this.checked;
    }
  }
};
</script>

<style lang="less">
.container-checkbox {
  display: block;
  position: relative;
  padding-left: 25px;
  // margin-top: 14px;
  margin-bottom: 14px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: #383838;
  font-size: 14px;
  font-weight: bold;
  .checkbox-check-indicator {
    position: absolute;
    top: 2px;
    left: 0;
    height: 16px;
    width: 16px;
    background-color: var(--inactive-color);
    border-radius: 2px;

    &:after {
      content: "";
      position: absolute;
      display: none;
    }

    &:after {
      left: 5px;
      top: 2px;
      width: 6px;
      height: 10px;
      border: solid var(--alabaster);
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:checked ~ .checkbox-check-indicator {
      background-color: var(--active-color);
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    }

    &:checked ~ .checkbox-check-indicator:after {
      display: block;
    }
  }

  input[type="checkbox"]:focus ~ .checkbox-check-indicator::before {
    content: "";
    width: 22px;
    height: 22px;
    border-radius: 2px;
    position: absolute;
    top: -3px;
    left: -3px;
    background: none;
    border: 1px solid var(--active-color);
  }
  &:hover input ~ .checkbox-check-indicator {
    filter: brightness(1.05);
  }
}
.container-checkbox span.light-label {
  color: #8f979c;
  font-size: 12px;
  font-weight: bold;
}
</style>
